export const getAddressLines = (address) => {
  const { street, street2, city, state, zip, email } = address;
  const stateAndZip = [state, zip].filter(Boolean)
    .join(' ');
  return [
    [street, street2].filter(Boolean),
    [city, stateAndZip].filter(Boolean),
    [email],
  ].map(lineArr => lineArr.join(', '));
};
